<div class="bannerPanel">
  <!-- <ngx-parallax-scroll>
      <img src="../../../assets/images/banner.png" parallax-img alt="img" />
    </ngx-parallax-scroll> -->
  <img src="../../../assets/homepage-images/banner.png" alt="img" />
  <div class="bannerContentSec">
    <div class="container">
      <div class="bannerContent animate__animated animate__backInLeft">
        <h2>Continuous | Quality | Delivery</h2>
        <h4> (Validate your applications rapidly and precisely) </h4>
        <p class="banner_paragraph">
          A comprehensive solution for providing world class test automation capabilities across Functional,
          Performance, Fault injection / Chaos & Mobile testing to Adobe Engineering community for enabling continuous quality
          and superior customer experience.
        </p>
        <!-- <button class="btn btn-primary btn-sm" type="button" (click)="openWelcomeDialog()">click</button> -->
        <div class="btnsLinks d-flex align-items-center justify-content-lg-center">
          <!-- <a routerLink="/help" id="nav-help" routerLinkActive="active" class="sendLink"> View Demo </a> -->
          <div>
            <a class="liveLink" href="#"><img src="../../../assets/homepage-images/live.png" alt="live" (click)="videoModal(video)" /></a>

            <ng-template #video let-modal>
              <div class="modal-body p-0">
                <video controls width="100%">
                  <source src="/assets/help-videos/relay_teaser.mp4" type="video/mp4"> Your browser does not support
                  HTML5 video.
                </video>
              </div>
            </ng-template>
          </div>
        </div>
      </div>
    </div>
    <div class="bannerTopImg d-none d-lg-block"><img src="../../../assets/homepage-images/circel-img.png" alt="img" class="bannerTopImg-style" /></div>
  </div>
</div>

<div class="fourBlocksPanel">
  <div class="container">
    <div class="fourBlocks row d-lg-flex" style="justify-content: center;">
      <div class="boxItem boxOne animate__animated animate__slideInUp col-md-6 col-xl-2"  ngbTooltip="Click Here">
        <div class="boxContent clickable" (click)="changePage('0');smoothScroll('carousel')">
          <div style="height: 9rem;">
            <h5>Functional Test Automation </h5>
            <p>
              A No-code Platform for test automation of REST API, UI. Increase test cycle velocity, less downtime, Response Validation to confirm 200 response code, insightful reports.
            </p>
          </div>
          <div class="boxBtns">
            <!-- <a class="animate__animated animate__bounceIn" >Explore</a> -->
          </div>
        </div>
        <div class="boxIcon"><img src="../../../assets/homepage-images/slide_iocn1.png" alt="icon" /></div>
      </div>
      <div class="boxItem boxFour animate__animated animate__slideInUp animate__delay-3s col-md-6 col-xl-2">
        <div class="boxContent clickable" (click)="changePage('1');smoothScroll('carousel')">
          <div style="height: 9rem;">
            <h5>Mobile Automation</h5>
            <p>A single stop solution for all the "Mobile - App" test automation needs, with wide coverage of Mobile
              devices across IOS, Android.</p>
          </div>
          <div class="boxBtns">
            <!-- <a class="animate__animated animate__bounceIn" (click)="changePage('3');smoothScroll('carousel')">Explore</a> -->
          </div>
        </div>
        <div class="boxIcon"><img src="../../../assets/homepage-images/slide_iocn4.png" alt="icon" /></div>
      </div>
      <div class="boxItem boxFive animate__animated animate__slideInUp animate__delay-1s col-md-6 col-xl-2">
        <div class="boxContent clickable" (click)="changePage('2');smoothScroll('carousel')">
          <div style="height: 9rem;">
            <h5>Desktop Automation</h5>
            <p>
              No-code solution for automating desktop tasks. Self-service is offered for applications on both Mac and Windows platforms.
            </p>
          </div>
          <div class="boxBtns" style="display: flex;">
            <!-- <a class="animate__animated animate__bounceIn" (click)="changePage('4'); smoothScroll('carousel')">Explore</a> -->
          </div>
        </div>
        <div class="boxIcon" style="opacity: 0.3; margin: 4px 8px;"><img style="max-height: 3.5rem;" src="../../../assets/images/navigation/desktop-automation.png" alt="icon" /></div>
      </div>
      <div class="boxItem boxTwo animate__animated animate__slideInUp animate__delay-1s col-md-6 col-xl-2">
        <div class="boxContent clickable" (click)="changePage('3');smoothScroll('carousel')">
          <div style="height: 9rem;">
            <h5>Performance <br> Lab</h5>
            <p>
              A central place fueled with executable platform to test your application/service/platform with variety of
              performance tests.
            </p>
          </div>
          <div class="boxBtns">
            <!-- <a class="animate__animated animate__bounceIn" (click)="changePage('1');smoothScroll('carousel')">Explore</a> -->
          </div>
        </div>
        <div class="boxIcon"><img src="../../../assets/homepage-images/slide_iocn2.png" alt="icon" /></div>
      </div>
      <div class="boxItem boxThree animate__animated animate__slideInUp animate__delay-2s col-md-6 col-xl-2">
        <div class="boxContent clickable" (click)="changePage('4');smoothScroll('carousel')">
          <div style="height: 9rem;">
            <h5> Chaos <br> Simulator </h5>
            <p>
              A self-service Chaos engineering platform enabling Engineering teams to build Resilient applications by offering
              Infra, Network and ALFI chaos attacks.
            </p>
          </div>
          <div class="boxBtns">
            <!-- <a class="animate__animated animate__bounceIn" (click)="changePage('2');smoothScroll('carousel')">Explore</a> -->
          </div>
        </div>
        <div class="boxIcon"><img src="../../../assets/homepage-images/slide_iocn3.png" alt="icon" /></div>
      </div>
    </div>
  </div>
</div>

<ngb-carousel id="carousel" pauseOnHover="true" [interval]="10000" [showNavigationIndicators]="false" [pauseOnHover]="true" [pauseOnFocus]="true" (touchstart)="posIni = $event.changedTouches[0].pageX" (touchend)="move($event.changedTouches[0].pageX)">
  <ng-template ngbSlide id="0">
    <div class="slideBLock blockOne" id="slideId1">
      <div class="slideContactSec">
        <div class="container">
          <div class="slideContact">
            <h3 class="slideTitle">Functional Test Automation</h3>
            <div class="benifitSec">
              <h5>Benefits</h5>
              <ul>
                <li>Test your E2E business flows by just clicking few configuration steps</li>
                <li>Continuous development</li>
                <li>Increase test cycle velocity</li>
                <li>Chaining the API and UI endpoints to create E2E workflows</li>
                <li>JSON extractor, Powerful data validations</li>
                <li> JIRA, Splunk integration</li>
              </ul>
              <div class="btnsSec d-flex">
                <a class="commonBtn" routerLink="/endpoint">Get Started</a>
                <a href="#" class="commonBtn" (click)="videoModal(FTAVideo)">View Demo</a>
                <ng-template #FTAVideo let-modal>
                  <div class="modal-body p-0">
                    <video controls width="100%">
                      <source src="/assets/help-videos/endpoint.mp4" type="video/mp4"> Your browser does not support HTML5
                      video.
                    </video>
                  </div>
                </ng-template>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="blockOneImg animate__animated animate__slideInRight animate__delay-2s d-none d-lg-block"><img src="../../../assets/homepage-images/diagram.png" alt="img" class="img-responsive" /></div>
    </div>
  </ng-template>
  <ng-template ngbSlide id="1">
    <div class="slideBLock blockFour" id="slideId4">
      <div class="blockFourInner d-lg-flex">
        <div class="leftBlock d-none d-lg-block">

          <img src="../../../assets/homepage-images/mobileimg.png" alt="img" />
        </div>
        <div class="rightBlock">
          <div class="rightBlkInner">
            <h3 class="slideTitle d-flex d-lg-block">Mobile <br>Automation</h3>
            <ul>
              <li>No/Low code test case creation</li>
              <li>A platform for "Mobile / Desktop" cross-over cases</li>
              <li>Helps in increased Mobile Device coverage.</li>
              <li>Reduce Operational burden of managing multiple mobile devices</li>
              <li>Enabling continuous testing with CI / CD integration</li>
              <li>Provides seamless integration with external platforms such as AWS Device Farm, Sauce Labs...etc.</li>
            </ul>
            <div class="btnsSec d-flex">
              <a href="#" class="commonBtn" routerLink="/mobileAutomation">Get Started</a>
              <a href="#" class="commonBtn" (click)="videoModal(mobileVideo)">View Demo</a>
              <ng-template #mobileVideo let-modal>
                <div class="modal-body p-0">
                  <video controls width="100%">
                    <source src="/assets/help-videos/mobile_automation.mp4" type="video/mp4"> Your browser does not support
                    HTML5 video.
                  </video>
                </div>
              </ng-template>
            </div>
          </div>
        </div>
      </div>
    </div>
  </ng-template>
  <ng-template ngbSlide id="2">
    <div class="slideBLock blockFive" id="slideId4">
      <div class="blockFourInner d-lg-flex">
      <div class="leftBlock d-none d-lg-block">
        <img class="blockFive-image" src="../../../assets/homepage-images/laptop.jpg" alt="img" />
      </div>
        <div class="rightBlock">
          <div class="rightBlkInner">
            <h3 class="slideTitle d-flex d-lg-block">Desktop <br>Automation</h3>
            <ul>
              <li>Enhanced accuracy, lower operating expenses, and better productivity are some benefits of desktop automation.</li>
              <li>Compatibility for Windows and Mac operating systems  applications</li>
              <li>Enhanced test data-driven test cases with validations, reports, and notifications</li>
              <li>Parallel execution speeds up the process of finishing test suites.</li>
              <li>Localization can be performed on the same test cases.</li>
            </ul>
            <div class="btnsSec d-flex">
              <a href="#" class="commonBtn" routerLink="/desktopAutomation">Get Started</a>
              <!-- <a href="#" class="commonBtn" (click)="videoModal(mobileVideo)">View Demo</a>
              <ng-template #mobileVideo let-modal>
                <div class="modal-body p-0">
                  <video controls width="100%">
                    <source src="/assets/help-videos/mobile_automation.mp4" type="video/mp4"> Your browser does not support
                    HTML5 video.
                  </video>
                </div>
              </ng-template> -->
            </div>
          </div>
        </div>
      </div>
    </div>
  </ng-template>
  <ng-template ngbSlide id="3">
    <div class="slideBLock blockTwo" id="slideId2">
      <div class="slideTwoyContecnt">
        <div class="container h-100">
          <div class="d-lg-flex">
            <h3 class="slideTitle d-flex justify-content-left">Performance <br>Lab</h3>
            <div class="btnsSec d-flex mt-5 ml-auto">
              <a href="#" class="commonBtn" routerLink="/performance">Get Started</a>
              <a href="#" class="commonBtn" (click)="videoModal(PerfLabVideo)">View Demo</a>
              <ng-template #PerfLabVideo let-modal>
                <div class="modal-body p-0">
                  <video controls width="100%">
                    <source src="/assets/help-videos/perfWizz_demo.mp4" type="video/mp4"> Your browser does not support HTML5
                    video.
                  </video>
                </div>
              </ng-template>
            </div>
          </div>
          <div class="roundPoints d-lg-flex">
            <span class="roundItem item1 animate__animated animate__rollIn d-block">
              <img src="../../../assets/homepage-images/performance5.svg" alt="img" class="d-none d-lg-block" height="70" width="70" />
              <p>Codeless Performance Testing</p>
            </span>
            <span class="roundItem item2 animate__animated animate__rollIn  d-block">
              <img src="../../../assets/homepage-images/performance4.svg" alt="img" class="d-none d-lg-block" height="70" width="70" />
              <p>Multi-Geo load simulation</p>
            </span>
            <span class="roundItem item3 animate__animated animate__rollIn  d-block">
              <img src="../../../assets/homepage-images/performance11.png" alt="img" class="d-none d-lg-block" height="60" width="90" />
              <p>Performance Trend Analysis</p>
            </span>
            <span class="roundItem item4 animate__animated animate__rollIn  d-block">
              <img src="../../../assets/homepage-images/performance2.svg" alt="img" class="d-none d-lg-block" height="70" width="70" />
              <p>Static Code profiling for Quality code</p>
            </span>
            <span class="roundItem item5 animate__animated animate__rollIn  d-block">
              <img src="../../../assets/homepage-images/performance1.svg" alt="img" class="d-none d-lg-block" height="70" width="70" />
              <p>Run-time statistics for spot and fix</p>
            </span>
            <span class="roundItem item6 animate__animated animate__rollIn  d-block">
              <img src="../../../assets/homepage-images/performance3.svg" alt="img" class="d-none d-lg-block" height="70" width="70" />
              <p>Enabling Performance Engineering culture from development cycles</p>
            </span>
          </div>
        </div>
      </div>
    </div>
  </ng-template>
  <ng-template ngbSlide id="4">
    <!-- Slide Three -->
    <div class="slideBLock blockThree" id="slideId3">
      <div class="slideThreeContecnt">
        <div class="container">
          <h3 class="slideTitle">Chaos <br> Simulator </h3>
          <ul>
            <li>Auto Chaos use case simulator</li>
            <li>Extensive support for infra & Network attacks</li>
            <li>Injecting failures in a precise and controlled manner</li>
            <li>Run books to enable self-service Chaos game days</li>
            <li>Broad coverage of Adobe Infra landscape: VMs, K8s, Ethos and Multi-cloud</li>
          </ul>
          <div class="btnsSec d-flex">
            <a href="#" class="commonBtn" routerLink="/chaos/overview">Get Started</a>
            <a href="#" class="commonBtn" (click)="videoModal(chaosVideo)">View Demo</a>
            <ng-template #chaosVideo let-modal>
              <div class="modal-body p-0">
                <video controls width="100%">
                  <source src="/assets/help-videos/chaos_simulator.mp4" type="video/mp4"> Your browser does not support
                  HTML5 video.
                </video>
              </div>
            </ng-template>
          </div>
        </div>
      </div>
    </div>
  </ng-template>
</ngb-carousel>


<!-- Questions? We have the answers. -->
<div class="questionsPanel">
  <div class="questionsTop">
    <div class="container">
      <div class="questionsInner d-flex align-items-center">
        <div class="questionsLeft">
          <h3 class="slideTitle">Questions?</h3>
          <h4>We have the answers.</h4>
        </div>
        <div class="questionsRight">
          <p>Have a question that’s not answered here? Reach out to</p>
          <p><a href="mailto:Grp-Relay-Team@adobe.com">{{'Grp-Relay-Team@adobe.com'}}</a></p>
        </div>
      </div>
    </div>
  </div>
  <div class="questionsBottom">
    <div class="container">

      <div class="accrodionList">
        <div class="accordion d-flex flex-wrap" id="accordionExample">
          <div class="accordion-item">
            <h2 class="accordion-header" id="headingOne">
              <button class="accordion-button" type="button" data-bs-toggle="collapse" data-bs-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne">
                Where can I find more information(FAQ) on Relay?
              </button>
            </h2>
            <div id="collapseOne" class="accordion-collapse collapse" aria-labelledby="headingOne" data-bs-parent="#accordionExample">
              <div class="accordion-body">
                <strong>Please visit <a href="https://wiki.corp.adobe.com/display/Relay/Relay+Support" target="_blank">FAQ</a> & <a href="https://wiki.corp.adobe.com/display/Relay/Relay+-+Checklist" target="_blank">Checklist</a></strong>
              </div>
            </div>
          </div>
          <div class="accordion-item">
            <h2 class="accordion-header" id="headingTwo">
              <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseTwo" aria-expanded="false" aria-controls="collapseTwo">
                Who all are using Relay?
              </button>
            </h2>
            <div id="collapseTwo" class="accordion-collapse collapse" aria-labelledby="headingTwo" data-bs-parent="#accordionExample">
              <div class="accordion-body">
                <strong><a href="https://app.powerbi.com/groups/me/apps/2ef02564-a5c1-44c0-a05d-1fd7f6233cbf/reports/172e817a-49f2-4ed2-bf3b-58fd0b5e72de/ReportSectionc5ad66c9e48ee2282238?chromeless=true" target="_blank">Click here</a> for customer details. </strong>
              </div>
            </div>
          </div>
          <div class="accordion-item">
            <h2 class="accordion-header" id="headingThree">
              <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseThree" aria-expanded="false" aria-controls="collapseThree">
                What is the availability of Relay platform ?
              </button>
            </h2>
            <div id="collapseThree" class="accordion-collapse collapse" aria-labelledby="headingThree" data-bs-parent="#accordionExample">
              <div class="accordion-body">
                Relay SLA is 99.95(3-95).
                <strong>
                  <a href="https://app.powerbi.com/groups/me/apps/fee6a203-c7e7-4d5c-bf16-830541fdc5c5/reports/0cd2a156-d77f-428b-aa81-7fe78d5e934a/ReportSectionfba8e6166a6badbc35e8?ctid=fa7b1b5a-7b34-4387-94ae-d2c178decee1&experience=power-bi" target="_blank">Click here</a>
                </strong>
                for SLX Dashboard
              </div>
            </div>
          </div>
          <div class="accordion-item">
            <h2 class="accordion-header" id="headingFour">
              <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseFour" aria-expanded="false" aria-controls="collapseFour">
                How can I Onboard to Relay?
              </button>
            </h2>
            <div id="collapseFour" class="accordion-collapse collapse" aria-labelledby="headingFour" data-bs-parent="#accordionExample">
              <div class="accordion-body">
                <strong> Please start with our <a href="https://wiki.corp.adobe.com/display/Relay/Relay+-+Workflows" target="_blank">OnboardingProcessFlow</a> . </strong>
              </div>
            </div>
          </div>
          <div class="accordion-item">
            <h2 class="accordion-header" id="headingFive">
              <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseFive" aria-expanded="false" aria-controls="collapseFive">
                How do I contact the Relay core team?
              </button>
            </h2>
            <div id="collapseFive" class="accordion-collapse collapse" aria-labelledby="headingFive" data-bs-parent="#accordionExample">
              <div class="accordion-body">
                <strong> <a href="mailto:Grp-Relay-Team@adobe.com">{{'Grp-Relay-Team@adobe.com'}}</a> </strong>
              </div>
            </div>
          </div>
          <div class="accordion-item">
            <h2 class="accordion-header" id="headingSix">
              <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseSix" aria-expanded="false" aria-controls="collapseSix">
                How can I Integrate to Relay?
              </button>
            </h2>
            <div id="collapseSix" class="accordion-collapse collapse" aria-labelledby="headingSix" data-bs-parent="#accordionExample">
              <div class="accordion-body">
                <strong>Please start with our <a href="https://wiki.corp.adobe.com/display/CTDxE/Relay+for+Integration+Tests#RelayforIntegrationTests-CommonHoolihanutilities" target="_blank">Relay Integration Guide?</a></strong>
              </div>
            </div>
          </div>
          <div class="accordion-item">
            <h2 class="accordion-header" id="headingSeven">
              <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseSeven" aria-expanded="false" aria-controls="collapseSeven">
                Where can I ask a question?
              </button>
            </h2>
            <div id="collapseSeven" class="accordion-collapse collapse" aria-labelledby="headingSeven" data-bs-parent="#accordionExample">
              <div class="accordion-body">
                <strong>
                  Via <a href="https://adobe-relay.slack.com/" target="_blank">Slack</a> channel
                  or send your queries to <a href="mailto:Grp-Relay-Team@adobe.com" target="_blank"> Grp-Relay-Team
                  </a>.
                </strong>
              </div>
            </div>
          </div>
          <div class="accordion-item">
            <h2 class="accordion-header" id="headingEight">
              <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseEight" aria-expanded="false" aria-controls="collapseEight">
                What is the support model of Relay platform?
              </button>
            </h2>
            <div id="collapseEight" class="accordion-collapse collapse" aria-labelledby="headingEight" data-bs-parent="#accordionExample">
              <div class="accordion-body">
                <strong>Please refer the <a href="https://wiki.corp.adobe.com/pages/viewpage.action?pageId=1465915935" target="_blank">Support Model Wiki</a> for more details.</strong>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

  </div>
</div>